import { Api } from '../lib'

const TYPE = {
  receive_all: 'RECEIVE_PRODUCTS',
  receive_featured: 'RECEIVE_FEAT_PRODUCTS'
}

const api = new Api()

const fetchProducts = (query, type) => (dispatch, getState) => api
  .get('products', {
    query
  })
  .then( product => {
    if(type === 'featured')
      dispatch({ type: TYPE.receive_featured, payload: product.data })
    else
      dispatch({ type: TYPE.receive_all, payload: product.data })
  })

export default {
  TYPE,
  fetchProducts
}
